export class Service {
  id: string;
  name: string;
  description: string;
  icon: string;
  createBy: string;
  createDate: string;
  serviceKeys: ServiceKey[];
}

export class ServiceKey {
  serviceId: string;
  key: string;
  priority: number;
}

export class ServiceSearchKeyOptions {
  serviceId: string;
  key: string;
  search: string;
}

export class ServiceSearchKey {
  value: string;
  description: string;
  dropdownName?: string;
}
